import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 break-word" }, " Kế hoạch ", -1)
const _hoisted_2 = {
  key: 1,
  class: "mb-0 break-word"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 break-word" }, " Toa Xe ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 break-word" }, " D/mục Toa Xe ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 break-word" }, " Ngày vào xưởng ", -1)
const _hoisted_6 = { class: "mb-0 break-word" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 break-word" }, " Ngày lập ", -1)
const _hoisted_8 = { class: "mb-0 break-word" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 break-word" }, " Cấp sửa chữa ", -1)
const _hoisted_10 = { class: "mb-0 break-word" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 break-word" }, " Ra xưởng? ", -1)
const _hoisted_12 = { class: "mb-0 break-word" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 break-word" }, " Có định mức động? ", -1)
const _hoisted_14 = { class: "d-flex justify-content-center flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_word_break_column = _resolveComponent("word-break-column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(_component_el_table, {
    size: "small",
    "cell-style": {padding: '0', height: '15px'},
    border: true,
    data: _ctx.bienBanItems,
    "empty-text": "Chưa có biên bản"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, {
        label: "ID",
        width: "50"
      }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(scope.row.id), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_word_break_column, {
        "header-title": "Số",
        property: "so_bien_ban"
      }),
      (_ctx.isKeHoachColumnDisplaying)
        ? (_openBlock(), _createBlock(_component_el_table_column, { key: 0 }, {
            header: _withCtx(() => [
              _hoisted_1
            ]),
            default: _withCtx((scope) => [
              (scope.row.ke_hoach_sua_chua)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    class: "mb-0 break-word",
                    to: `/quan-ly/ke-hoach-sua-chua/chi-tiet/${scope.row.ke_hoach_sua_chua.id}`
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scope.row.ke_hoach_sua_chua?.ten_ke_hoach), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : (_openBlock(), _createElementBlock("p", _hoisted_2, " - "))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_table_column, null, {
        header: _withCtx(() => [
          _hoisted_3
        ]),
        default: _withCtx((scope) => [
          _createVNode(_component_router_link, {
            to: `/quan-ly/toa-xe/${scope.row.toa_xe.id}/chi-tiet`
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(scope.row.toa_xe.ma_toa_xe) + " - " + _toDisplayString(scope.row.toa_xe.ten_toa_xe), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, null, {
        header: _withCtx(() => [
          _hoisted_4
        ]),
        default: _withCtx((scope) => [
          (_ctx.toaXeHasDmtx(scope.row.toa_xe))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: `/quan-ly/danh-muc-toa-xe/${scope.row.toa_xe.danh_muc_toa_xe?.[0]?.id}/chi-tiet`
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(scope.row.toa_xe.danh_muc_toa_xe?.[0]?.ten_danh_muc || '-'), 1)
                ]),
                _: 2
              }, 1032, ["to"]))
            : (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: `/quan-ly/danh-muc-toa-xe/danh-sach`
              }, {
                default: _withCtx(() => [
                  _createTextVNode("- ")
                ]),
                _: 1
              }))
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, null, {
        header: _withCtx(() => [
          _hoisted_5
        ]),
        default: _withCtx((scope) => [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.moment(scope.row.ngay_vao_xuong).format('DD-MM-YYYY')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, null, {
        header: _withCtx(() => [
          _hoisted_7
        ]),
        default: _withCtx((scope) => [
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.moment(scope.row.ngay_lap).format('DD-MM-YYYY')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, null, {
        header: _withCtx(() => [
          _hoisted_9
        ]),
        default: _withCtx((scope) => [
          _createElementVNode("p", _hoisted_10, _toDisplayString(scope.row.ke_hoach_sua_chua?.cap_sua_chua?.ten_cap_sc ||
            scope.row.cap_sua_chua?.ten_cap_sc), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, null, {
        header: _withCtx(() => [
          _hoisted_11
        ]),
        default: _withCtx((scope) => [
          _createElementVNode("p", _hoisted_12, _toDisplayString(!!_ctx.bienBanItems[scope.$index].ngay_ra_xuong ? _ctx.moment(_ctx.bienBanItems[scope.$index].ngay_ra_xuong).format('DD-MM-YYYY') : '-'), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "Đã duyệt?",
        width: "90"
      }, {
        default: _withCtx((scope) => [
          _createVNode(_component_el_checkbox, {
            modelValue: _ctx.bienBanItems[scope.$index].is_approved,
            "onUpdate:modelValue": ($event: any) => ((_ctx.bienBanItems[scope.$index].is_approved) = $event),
            disabled: ""
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, { width: "90" }, {
        header: _withCtx(() => [
          _hoisted_13
        ]),
        default: _withCtx((scope) => [
          _createVNode(_component_el_checkbox, {
            modelValue: _ctx.bienBanItems[scope.$index].has_dinh_muc_dong,
            "onUpdate:modelValue": ($event: any) => ((_ctx.bienBanItems[scope.$index].has_dinh_muc_dong) = $event),
            disabled: ""
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        width: "150",
        fixed: "right"
      }, {
        default: _withCtx((scope) => [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_ButtonCustom, {
              "button-type": _ctx.ButtonsType.INFO,
              "color-type": _ctx.ButtonTypeColors.INFO,
              onClick: ($event: any) => (_ctx.$emit('on-detail-click', { id: scope.row.id }))
            }, null, 8, ["button-type", "color-type", "onClick"]),
            (_ctx.isHoanThanhButtonDisplayed && !_ctx.bienBanItems[scope.$index].ngay_ra_xuong)
              ? (_openBlock(), _createBlock(_component_ButtonCustom, {
                  key: 0,
                  "button-type": _ctx.ButtonsType.EDIT,
                  "color-type": _ctx.ButtonTypeColors.SUCCESS,
                  onClick: ($event: any) => (_ctx.$emit('on-edit-click', { id: scope.row.id }))
                }, null, 8, ["button-type", "color-type", "onClick"]))
              : _createCommentVNode("", true),
            (_ctx.isHoanThanhButtonDisplayed && !_ctx.bienBanItems[scope.$index].ngay_ra_xuong)
              ? (_openBlock(), _createBlock(_component_ButtonCustom, {
                  key: 1,
                  "button-type": _ctx.ButtonsType.FA_CHECK_SQUARE,
                  "color-type": _ctx.ButtonTypeColors.PRIMARY,
                  onClick: ($event: any) => (_ctx.$emit('on-check-click', { id: scope.row.id }))
                }, null, 8, ["button-type", "color-type", "onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["data"]))
}